export default "https://cdn-static.gokick.com/assets/392c20f622263512bf2611e9ba1d645afacce893/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";